import { useEffect, useRef } from 'react';

const ACTIVITY_EVENTS = ['pointerdown', 'keydown', 'touchstart', 'scroll'];

// Calls onIdle once after `timeoutMs` without any touch, click, key or scroll
export function useIdleTimer(timeoutMs, onIdle, { enabled = true } = {}) {
  const onIdleRef = useRef(onIdle);
  onIdleRef.current = onIdle;

  useEffect(() => {
    if (!enabled) return undefined;
    let timer = setTimeout(() => onIdleRef.current(), timeoutMs);
    const reset = () => {
      clearTimeout(timer);
      timer = setTimeout(() => onIdleRef.current(), timeoutMs);
    };
    ACTIVITY_EVENTS.forEach(ev => document.addEventListener(ev, reset, { passive: true }));
    return () => {
      clearTimeout(timer);
      ACTIVITY_EVENTS.forEach(ev => document.removeEventListener(ev, reset));
    };
  }, [timeoutMs, enabled]);
}
